
const host_state = (require('../../build/status')).status  //true为正式，false为测试

// 测试接口
let host = 'https://xfq-api.52shanglu.com';
// let host = 'https://shopingapi.guogekeji.com';
let uploadUrl = ''

if (host_state) {
    // 正式接口
    host = 'https://qutao-api.wantaobaby.com';
}

export default {
    host,
    uploadUrl,
}